<template>
	<div>
		<div class="wrap" :class="{ is_fixed: isFixed }">
			<div class="wrap-center">
				<a class="logo" href="./" title="江西正能智慧科技有限公司" >
					<img :src="logoimg" alt="" />
				</a>
				
				<div class="nav-view">
					<div class="nav">
					
						<ul>
							<li
								v-for="(item, index) in navList"
								:key="index"
								@click="funyuming(item.url)"
							>
								<div class="nav-div">{{ item.title }}</div>
	
								<div class="dropdown">
									<div class="dropdown-content">
										<router-link to="/keji" v-for="(e, index) in item.children"
										:key="index">{{e.title}}</router-link>
										
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="head-hotline">
						<i class="icon icon-phone"></i>
						<span>全国服务热线：400-889-9805</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Nav",
	data() {
		return {
			navList: [
				{ title: "首页", url: "/" },
				{ 
					title: "解决方案", 
					url: "/solution",
				},
				{ title: "产品中心", url: "/product" },
				// { title: "电力设备", url: "/zhaopinxinxi0" },
				{ title: "新闻资讯", url: "/news" },
				{ title: "应用下载", url: "/download" },
				{ title: "关于我们", url: "/AboutUs" },
				{ title: "联系我们", url: "/contactUs" },
				
			],
			logoimg: require("../assets/img/nygl_logo.png"),
			isFixed: false,
		};
	},
	mounted(){
		window.addEventListener("scroll", this.showIcon);
	},
	methods: {

		// 滚动函数事件
		showIcon() {
			if (
				!!document.documentElement.scrollTop &&
				document.documentElement.scrollTop > 20
			) {            
				this.isFixed = true;
			} else {
				this.isFixed = false;
			}
		},
		funyuming(msg) {
			this.$router.push(msg);
		},
		funRouter() {
			this.$router.push("/keji");
		},
	},
};
</script>
<style scoped>
.wrap {
	/*position: fixed;*/
	position: fixed;
	width: 100vw;
	height: 90px;
	left: 0;
	top: 0;
	background-color: #242632;	
	/*background-color: rgba(255, 255, 255, 0.6);*/
	box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);
	z-index: 3;
	
}
.wrap.is_fixed {
	background-color: #242632;
}
.wrap:hover{
	background-color: #242632;	
}
.wrap > .wrap-center{
	width: 1400px;
	margin: 0 auto;
	height: 90px;
	position: relative;
	display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}
.wrap > .wrap-center > .logo{
	display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
	height: 90px;
}
.wrap > .wrap-center > .logo > img {
	
	width: 120px;
	display: block;
}
.nav-view{
	align-items: center;
	display: flex;

}
.nav {
}

.nav ul {
	height: 100%;
}
.head-hotline{
	color: #fff;
    margin-left: 40px;
	display: -webkit-flex;
    display: flex;
}
.head-hotline span {
    font-size: 15px;
    white-space: nowrap;
	line-height: 25px;
	margin-left: 5px
}
.nav ul li {
	height: 90px;
	float: left;
	display: flex;
	list-style-type: none;
	color: #ffffff;
	font-size: 15px;
	
	line-height: 90px;
	cursor: pointer;
	position: relative;
}

.nav ul li:hover {
	background-color: #4CCE9D;
}
.nav ul li .nav-div{
	padding: 0 15px;
	min-width: 105px;
	text-align: center;
}
.nav ul li .nav-div:hover::before {
    top: 50%;
    transform: translateY(-50%);
    opacity: 1;
    transition: all 0.5s;
}
.nav ul li .nav-div::before {
    content: '';
    position: absolute;
    left: 0;
    top: -4.09rem;
    width: 1px;
    height: 4.09rem;
    background: linear-gradient(to top, transparent, #fff, transparent);
    opacity: 0;
    transition: all 0.5s;
}
.nav ul li .nav-div:hover::after {
    bottom: 50%;
    transform: translateY(50%);
    opacity: 1;
    transition: all 0.5s;
}
.nav ul li .nav-div::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: -4.09rem;
    width: 1px;
    height: 4.09rem;
    background: linear-gradient(to top, transparent, #fff, transparent);
    opacity: 0;
    transition: all 0.5s;
}
.nav ul li:hover .dropdown-content{
	display: block;
}
.dropbtn {
	
	color: rgba(68, 68, 68, 1);
	padding: 16px;
	font-size: 16px;
	border: none;
	cursor: pointer;
}

.dropdown {
	top: 90px;
    left: 0;
    position: absolute;
	display: inline-block;
}

.dropdown-content {
	text-align: center;
	display: none;
	background-color: rgba(0, 0, 0, 0.85);
	min-width: 125px;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}
/*.dropdown-content::before {
    content: '';
    position: absolute;
    left: 50%;
	transform: translate(-50%, 0);
    top: 5px;
    z-index: 3;
	width: 0;
	height:0;
	border-bottom:15px solid rgba(0, 0, 0, 0.85) ;
	border-left:15px solid transparent;
	border-right:15px solid transparent;
	
}*/
.dropdown-content a {
	color: #ffffff;
	padding: 14px 16px;
	text-decoration: none;
	display: block;
	line-height: initial;
}

.dropdown-content a:hover {
	color: #0096a3;
}

.dropdown:hover .dropdown-content {
	display: block;
}
</style>
